export const UPLOAD_IMAGE =
  'src/modules/imageCroppingModal/UPLOAD_IMAGE';
export const SET_LOADER =
  'src/modules/imageCroppingModal/SET_LOADER';
